import Icon3PL from "../../../../layout/icons/Icon3PL";
import { DailyPickupMarker } from "../../../mapComponents/Markers";
import TrailerDropHookIcon from "../RouteExecution/utils/DriverStatus/Icons/TrailerDropHookIcon";
import { ExcessiveLength, TrailerDrop, CustomerComments } from "../icons";
import {SVG_ICON_NAME} from "../../../../appConstants";

const getSvgIcons = (iconName, color, size) => {
  switch (iconName) {
    case SVG_ICON_NAME._3PL:
      return <Icon3PL color={color} size={size} />;
    case SVG_ICON_NAME.SWAP:
      return <TrailerDropHookIcon color={color} size={size} />;
    case SVG_ICON_NAME.dailyPickup:
      return <DailyPickupMarker color={color} size={size} />;
    case SVG_ICON_NAME.ExcessiveLength: 
      return <ExcessiveLength color={color} size={size} />;
    case SVG_ICON_NAME.isTrailerDrop:
      return <TrailerDrop color={color} size={size} />;
    case SVG_ICON_NAME.CustomerComments:
    case SVG_ICON_NAME.ShipperComments:
      return <CustomerComments color={color} size={size} />;
    default:
      return null;
  }
};

export { getSvgIcons };
